import request from '@/utils/request'
export const queryLevel = (username: any) => {
  return request({
    url: `/user/permissionLevel/${username}`,
    method: 'get'
  })
}
// 预约查询列表页接口
export const getOrderDetailPage = (params: any) => {
  return request({
    url: '/userinfo/conditionSearch',
    method: 'get',
    params
  })
}
// 体检查询列表页接口
export const getOrderDetailPage2 = (params: any) => {
  return request({
    url: '/userinfo/conditionSearch2',
    method: 'get',
    params
  })
}
// 证件查询列表页接口
export const getOrderDetailPage3 = (params: any) => {
  return request({
    url: '/userinfo/conditionSearch3',
    method: 'get',
    params
  })
}

//查询用户名称接口
export const getUserList = (params: any) => {
  return request({
    url: '/userinfo/getUserList',
    method: 'get',
    params
  })
}

// 查看接口
export const queryOrderDetailById = (params: any) => {
  return request({
    url: `/userinfo/details/${params.orderId}`,
    method: 'get'
  })
}
// 体检查看接口
export const queryOrderDetailById2 = (params: any) => {
  return request({
    url: `/userinfo/check/${params.orderId}`,
    method: 'get'
  })
}
// 证件查看接口
export const queryZjDetailById = (params: any) => {
  return request({
    url: `/userinfo/zjDetails/${params.orderId}`,
    method: 'get',
    params
  })
}
// //颁发证件接口
// export const issued = (params: any) => {
//   return request({
//     url: `/zj/issued/${params.orderId}`,
//     method: 'post'
//   })
// }


//预约审核通过接口
export const passAudit = (params: any) => {
  return request({
    url: `/userinfo/audit`,
    method: 'put',
    data: { ...params },
  })
}
//体检审核通过接口
export const passAudit2 = (params: any) => {
  return request({
    url: `/userinfo/bodyaudit`,
    method: 'put',
    data: { ...params },
  })
}
//证件审核
export const passAudit3 = (params: any) => {
  return request({
    url: `/userinfo/zjaudit`,
    method: 'put',
    data: { ...params },
  })
}
//证件上传
export const zjUpload = (params: any) => {
  return request({
    url: `/userinfo/upload2`,
    method: 'post',
    data: { ...params },
  })
}
//健康证上传（单条，前端只传订单id，由后端组装数据并调用健康证平台）
export const healthCertUpload = (params: any) => {
  return request({
    url: `/userinfo/healthCertUpload`,
    method: 'post',
    data: { ...params },
  })
}
//健康证批量上传（前端只传订单id列表，由后端组装数据并调用健康证平台，单次最多100条）
export const healthCertBatchUpload = (params: any) => {
  return request({
    url: `/userinfo/healthCertBatchUpload`,
    method: 'post',
    data: { ...params },
  })
}
export const healthCertBatchResult = (params: any) => {
  return request({
    url: `/userinfo/healthCertBatchResult`,
    method: 'post',
    data: { ...params },
  })
}
export const healthCertBatchCerts = (params: any) => {
  return request({
    url: `/userinfo/healthCertBatchCerts`,
    method: 'post',
    data: { ...params },
  })
}
export const healthCertQuery = (params: any) => {
  return request({
    url: `/userinfo/healthCertQuery`,
    method: 'post',
    data: { ...params },
  })
}

 /* 预约审核*/
export const orderAccept = (params: any) => {
  return request({
    url: '/userinfo/audit',
    method: 'put' /*  */,
    data: { ...params }
  })
}

//获取根据预约状态: 1.待审核 2.审核通过 3.审核未通过 的数量
export const getOrderListBy = (params: any) => {
  return request({
    url: '/userinfo/statistics',
    method: 'get' /*  */
  })
}
//获取根据体检状态: 1.待体检 2.体检未通过 3.体检通过待审核 4.体检通过已审核 的数量
export const getOrderListBy2 = (params: any) => {
  return request({
    url: '/userinfo/statistics2',
    method: 'get' /*  */
  })
}
// 获取证件状态：1.待上传 2.待颁发 3.已颁发数量
export const getOrderListBy3 = (params: any) => {
  return request({
    url: '/userinfo/statistics3',
    method: 'get' /*  */
  })
}
//体检预览
export const orderPrint = (orderId: number) => {
  return request({
    url: `/exportWord/${orderId}`,
    method: 'get',
    responseType: 'arraybuffer',//一定要设置响应类型，否则页面会是空白pdf
  }).then(response => response.data);
}
//打印证件
export const orderPrint2 = (orderId: number) => {
  return request({
    url: `/exportWord2/${orderId}`,
    method: 'get',
    responseType: 'arraybuffer',//一定要设置响应类型，否则页面会是空白pdf
  }).then(response => response.data);
}
// 假设 request 是一个已经配置好的 HTTP 客户端函数，能够处理 FormData
export const uploadFile = (file: File) => {
  const formData = new FormData();
  formData.append('file', file); // 'file' 是后端期望的字段名

  // 注意：这里我们没有手动设置 Content-Type，因为 request 函数应该能够处理 FormData
  return request({
    url: '/common/upload',
    method: 'post',
    data: formData, // 将 formData 作为请求体发送
    // 如果 request 函数需要额外的配置来正确处理 FormData，可以在这里添加
    // 例如，对于某些封装的 Axios 实例，你可能不需要做任何额外的事情
  });
};


//新增预约
export const addOrder = (params: any) => {
  return request({
    url: '/userinfo/upload',
    method: 'post',
    data: params
  })
}

//根据id查询预约信息
export const queryResvDetailById = (id: number) => {
  return request({
    url: `/userinfo/details/${id}`,
    method: 'get',
  })
}

//查询是否有未审核预约信息
export const queryResvDetail = () => {
  return request({
    url: `/userinfo/details2`,
    method: 'get',
  })
}

//根据certificateNumber查询预约信息
export const queryResvDetailByCertificateNumber = (params: any) => {
  return request({
    url: `/userinfo/details`,
    method: 'put',
    data: params
  })
}

//修改预约信息
export const updateOrder = (params: any) => {
  return request({
    url: '/userinfo/update',
    method: 'put',
    data: params
  })
}

//更新预约审核不通过原因
export const updateOrder2 = (params: any) => {
  return request({
    url: '/userinfo/update2',
    method: 'put',
    data: params
  })
}

//删除预约信息
export const deleteOrder = (ids: string) => {
  return request({
    url: '/userinfo/delete',
    method: 'delete',
    params: { ids }
  })
}

//批量打印
// 前端修改
export const allPrint = (ids: string[]) => {
  return request({
    url: '/allPrint',
    method: 'get',
    params: {
      ids: ids.join(',')
    },
    responseType: 'blob' // 重要：告诉axios我们期望接收二进制数据
  })
}

export const deleteZj = (ids: string) => {
  return request({
    url: '/userinfo/deleteZj',
    method: 'delete',
    params: { ids }
  })
}

//根据企业名查询其余信息
export const getCompanyByCompanyName = (companyName: string) => {
  return request({
    url: `/userinfo/checkCompanyName/${companyName}`,
    method: 'get',
  })
}

export const companyFuzzyQuery = (companyName: string) => {
  return request({
    url: `/companyFuzzyQuery/${companyName}`,
    method: 'get',
  })
}
// 上传身份证回显数据
// export const getDataByIdCard = (imageUrl: string) => {
//   return request({
//     url: `/ocr/idcard/${imageUrl}`,
//     method: 'get',
//   })
// }
export const getDataByIdCard = (imageUrl: string) => {
  return request({
    url: '/ocr/idcard',
    method: 'post',
    data: { imageUrl: imageUrl }
  })
}

// 上传营业执照回显数据
export const getDataByCert = (imageUrl: string) => {
  return request({
    url: '/ocr/cert',
    method: 'post',
    data: { imageUrl: imageUrl }
  })
}

//新增体检
export const addOrder2 = (params: any) => {
  return request({
    url: '/userinfo/uploadPe',
    method: 'post',
    data: params
  })
}
export const editPeResult = (params: any) => {
  return request({
    url: '/userinfo/userinput',
    method: 'put',
    data: params
  })
}

export const handlePeResult = (uid: number) => {
  return request({
    url: `/userinfo/peResult/${uid}`,
    method: 'put',
  })
}

//体检管理界面的批量打印
export const batchExportWord = (orderIds: number[]) => {
  return request({
    url: '/batchExportWord',
    method: 'post',
    data: { ids: orderIds }, // 传递id数组
    responseType: 'arraybuffer', // 二进制流
  }).then(response => response.data);
};
